// see: https://github.com/elboletaire/password-strength-meter
$(document).ready(() => {
  // password-strength-meter initialization
  if ($('#passwordInputField').length) {
    $('#passwordInputField').password({
      shortPass: 'The password is too short',
      badPass: 'Weak; try combining letters and numbers',
      goodPass: 'Medium; try adding more words or special characters',
      strongPass: 'Strong password',
      containsUsername: '',
      enterPass: '',
      showPercent: false,
      showText: true,
      animate: true,
      animateSpeed: 'fast',
      username: false,
      usernamePartialMatch: false,
      minimumLength: 6
    });
  }
});
